export const todayGroupHeader = "wRd";
export const yesterdayGroupHeader = "xRd";
export const thisWeekGroupHeader = "yRd";
export const lastWeekGroupHeader = "zRd";
export const thisMonthGroupHeader = "ARd";
export const lastMonthGroupHeader = "BRd";
export const olderGroupHeader = "CRd";
export default {todayGroupHeader,yesterdayGroupHeader,thisWeekGroupHeader,lastWeekGroupHeader,thisMonthGroupHeader,lastMonthGroupHeader,olderGroupHeader};